import React, {useState, useEffect, useRef} from "react";
import {Link, useNavigate, NavLink} from "react-router-dom";
import {notification, Button, Modal, Select, Checkbox, Tooltip} from 'antd';

import FrameIO from "../assets/images/frame.io.svg";
import ibm from "../assets/images/ibm.svg";
import awsLogo from "../assets/images/new-logos/aws-cloud-brand-logo.svg";
import azureLogo from "../assets/images/new-logos/azure-cloud-brand-logo.svg";
import googleCloudLogo from "../assets/images/new-logos/googleCloud.svg";
import wasabiCloudLogo from "../assets/images/new-logos/wasabi-cloud-brand-logo.svg";
import seagateLogo from "../assets/images/new-logos/seagate-logo.svg";
import NFSNewLogo from "../assets/images/new-logos/nfs.svg";
import SMBLogo from "../assets/images/new-logos/smb.svg";
import storjLogo from "../assets/images/new-logos/storj.svg";
import s3Logo from "../assets/images/new-logos/any-s3new.svg";
import DigitalOcean from "../assets/images/new-logos/digitalocean-logo-vector-1.svg";
import Backblaze from "../assets/images/new-logos/Backblaze.svg";
import ovhLogo from "../assets/images/new-logos/OVH.svg";
import perifery from "../assets/images/new-logos/perifery-logo.svg";
import box from "../assets/images/new-logos/box.svg";
import dropBox from "../assets/images/new-logos/dropbox.svg";
import googleDrive from "../assets/images/new-logos/Googledrive.svg";
import oneDrive from "../assets/images/new-logos/one-drive.svg";
import noData from "../assets/images/add-icon.png";
import toastIcon from "../assets/images/icons/toast-icon.svg";
import warning from "../assets/images/icons/warning-sign.svg";
import {useAuth} from "../context/AuthContext";
import config from "../config";
import pageLogo from "../assets/images/logo.svg";
import popupImage from "../assets/images/popup-image.jpg";
import pageLogoWhite from "../assets/images/logo-dark.svg";
import AmoveStorage from "../components/SetupAmoveStorage";
import SetupNFS from "../components/SetupNFS";
import farmeIOIcon from "../assets/images/new-logos/frame.io.svg";
import Cloudflare from "../assets/images/new-logos/Cloudflare_Logo.svg";
import idrive from "../assets/images/new-logos/e2_logo_white_03.svg";
import searchIcon from "../assets/images/icons/search-gray-icon.svg";
import crossBalckIcon from "../assets/images/icons/tour-cross-black-icon.svg";
import {LoadingOutlined} from '@ant-design/icons';
import {Spin} from 'antd';
import ProvisionAmoveStorage from "../components/ProvisionAmoveStorage";

const AddCloudAccount = () => {
    const {
        getData,
        updateCloudAccounts,
        setUpdateCloudAccounts,
        cloudAccounts,
        getCloudAccounts,
        logout,
        isCMDDone,
        agentIsRunning,
        checkAgent,
        cloudCounts,
        getIcon,
        cloudAccountsDone,
        sendDataToMixPanel,
        user,
        isDark,
        setHideBTNs,
        getDataWithTokenPOST,
        hideBTNs,
        isWindows,
        postDataWebNoResponse,
        setPopup500,
        setPopupSupport,
        setEndpoint,
        setShowPopupSupport,
        showTourConnections,
        setShowTourConnections,
        setShowTourDashboard,
        getDataWithToken,
        setAgentPopupOpen,
        setError499,
        setPopup499
    } = useAuth();
    const navigate = useNavigate();
    const dataFetchedRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const [loadingAmove, setLoadingAmove] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [isCreateStorage, setIsCreateStorage] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [connectedCloudDrives, setConnectedCloudDrives] = useState(0);
    const [chcekPrivacy, setChcekPrivacy] = useState(false);
    const [showAgentOnce, setShowAgentOnce] = useState(false);
    const [radioCheck, setRadiaCheck] = useState({
        'name': "",
        'logo': "",
        'text': "",
        'width': "",
        'value': "",
        'type': "",
        'isActive': false
    })
    const [cloudDetail, setCloudDetail] = useState([]);
    const [errorText, setErrorText] = useState('');
    const [showFreeStorage, setShowFreeStorage] = useState(true);
    const [showButtons, setShowButtons] = useState(false);
    const [showSingleButton, setShowSingleButton] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const urlParams = new URLSearchParams(window.location.search);
    const startTour = urlParams.get('startTour')
    const [regions, setRegions] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState("Select a Region");
    const [showOnlyToolTip, setShowOnlyToolTip] = useState(true);
    const OnboardingAgentOk = () => {
        setShowAgentOnce(false)
        navigate("/add-cloud-account");
    };

    const OnboardingAgentCancel = () => {
        setShowAgentOnce(false)
        navigate("/add-cloud-account");
    };

    const inputEvent = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        // setPrivacyValue
        if (value === "onlyMe") {
            setChcekPrivacy(false)
        } else if (value === "organization") {
            setChcekPrivacy(true)
        }
        if (value.length > 1) {
            event.target.classList.add('active')
        } else {
            event.target.classList.remove('active')
        }

        setShowError(false);

        setCloudDetail((lastValue) => {
            return {
                ...lastValue,
                [name]: value,
                ['cloudType']: parseInt(radioCheck.type),
                ['shared']: chcekPrivacy
            }
        });

        if (event.key === 'Enter') {
            addCloudAccount();
        }
    }

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        if (cloudAccounts.length < 1) {
            getCloudAccounts();
        }

        if (startTour === "true") {
            setShowTourConnections(true)
        }
        getDataWithToken('/api/cloudaccount/idrive_regions')
            .then((res) => Promise.all([res.status, res.json()]))
            .then(([status, response]) => {
                setLoading(false);
                if (status === 401) {
                    logout()
                    return;
                }
                if (status === 500) {
                    setPopup500(true);
                    setLoading(false);
                    return;
                }
                if (status === 499) {
                    var errorType = response.type;
                    setError499(response.errors[errorType][0])
                    setPopup499(true)
                    setShowFreeStorage(false);
                    return;
                }
                setRegions(response)
            });
    }, []);

    useEffect(() => {
        if(cloudCounts.length === 0 || (cloudAccounts.filter((item) => item.internalStorage).length > 0 && cloudAccountsDone && cloudCounts.length === 1 && (localStorage.getItem("showOnlyToolTip") === null))){
            setShowOnlyToolTip(true)
        }else{
            setShowOnlyToolTip(false)
            localStorage.setItem("showOnlyToolTip","false")
        }
    }, [cloudCounts]);


/*    useEffect(() => {
        setTimeout(function () {
            if (cloudAccounts.length > 0 && cloudAccountsDone) {
                if (cloudAccounts.filter((item) => item.internalStorage).length < 1) {
                    setShowFreeStorage(true);
                }
            } else if (cloudAccountsDone) {
                setShowFreeStorage(true);
            }
        }, 500)
    }, [cloudAccounts, cloudAccountsDone]);*/


    useEffect(() => {
        getData('/Management/clouddrive')
            .then((res) => Promise.all([res.status, res.json()]))
            .then(([status, data]) => {
                setLoading(false);
                if (status === 401) {
                    logout()
                    return;
                }
                if (status === 500) {
                    setPopup500(true);
                    return;
                }
                if (status === 499) {
                    var errorType = data.type;
                    setError499(data.errors[errorType][0])
                    setPopup499(true)
                    return;
                }
                setConnectedCloudDrives(data.length)
                setShowMessage(true);
            })
    }, [isCMDDone]);


    function clearFields() {
        var inputs = document.querySelectorAll('.field-wrapper input')
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].value = '';
        }
    }

    const onChangeCloud = (event) => {
        const name = event.target.name;
        const type = event.target.value;
        const value = event.target.getAttribute('data-name');
        const logo = event.target.getAttribute('data-logo');
        const text = event.target.getAttribute('data-text');
        const width = event.target.getAttribute('data-width');
        const isActive = true;
        document.querySelectorAll('.form-control').forEach(el => {
            el.classList.remove('active')
        });
        setShowError(false);
        clearFields();
        setCloudDetail([])
        setRadiaCheck(s => ({...s, name, logo, text, width, value, type, isActive}));
    }
    const [api, contextHolder] = notification.useNotification();
    const addCloudAccount = () => {
        let newArr = cloudDetail;
        setLoading(true);
        setAgentPopupOpen(false)
        if (radioCheck.type == 128) {
            var redirectURL = config.callbackURL + "/dropbox";
            var cloudName = newArr.name;

            var dataToPost = {
                "redirectURL": redirectURL,
                "cloudName": cloudName
            }

            postDataWebNoResponse('/api/desktop/generate_dropbox_authorization_url', dataToPost)
                .then((res) => Promise.all([res.status, res.text()]))
                .then(([status, data]) => {
                    if (status === 401) {
                        logout()
                        return;
                    }
                    if (status === 500) {
                        setPopup500(true)
                        return;
                    }
                    if (status === 499) {
                        var dataNew = JSON.parse(data)
                        var errorType = dataNew.type;
                        setError499(dataNew.errors[errorType][0])
                        setPopup499(true)
                        return;
                    }
                    setShowTourConnections(false)
                    window.location.href = data;
                })


        } else if (radioCheck.type == 256) {
            var redirectURL = config.callbackURL + "/box";
            var cloudName = newArr.name;

            var dataToPost = {
                "redirectURL": redirectURL,
                "cloudName": cloudName
            }

            postDataWebNoResponse('/api/desktop/generate_box_authorization_url', dataToPost)
                .then((res) => Promise.all([res.status, res.text()]))
                .then(([status, data]) => {
                    if (status === 401) {
                        logout()
                        return;
                    }
                    if (status === 500) {
                        setPopup500(true)
                        return;
                    }
                    if (status === 499) {
                        var dataNew = JSON.parse(data)
                        var errorType = dataNew.type;
                        setError499(dataNew.errors[errorType][0])
                        setPopup499(true)
                        return;
                    }
                    setShowTourConnections(false)
                    window.location.href = data;
                })


        } else if (radioCheck.type == 512) {
            var redirectURL = config.callbackURL + "/onedrive";
            var cloudName = newArr.name;

            var dataToPost = {
                "redirectURL": redirectURL,
                "cloudName": cloudName
            }

            postDataWebNoResponse('/api/desktop/generate_onedrive_authorization_url', dataToPost)
                .then((res) => Promise.all([res.status, res.text()]))
                .then(([status, data]) => {
                    if (status === 401) {
                        logout()
                        return;
                    }
                    if (status === 500) {
                        setPopup500(true)
                        return;
                    }
                    if (status === 499) {
                        var dataNew = JSON.parse(data)
                        var errorType = dataNew.type;
                        setError499(dataNew.errors[errorType][0])
                        setPopup499(true)
                        return;
                    }
                    setShowTourConnections(false)
                    window.location.href = data;
                })


        } else if (radioCheck.type == 1024) {
            var redirectURL = config.callbackURL + "/googledrive";
            var cloudName = newArr.name;

            var dataToPost = {
                "redirectURL": redirectURL,
                "cloudName": cloudName
            }
            postDataWebNoResponse('/api/desktop/generate_googledrive_authorization_url', dataToPost)
                .then((res) => Promise.all([res.status, res.text()]))
                .then(([status, data]) => {
                    if (status === 401) {
                        logout()
                        return;
                    }
                    if (status === 500) {
                        setPopup500(true)
                        return;
                    }
                    if (status === 499) {
                        var dataNew = JSON.parse(data)
                        var errorType = dataNew.type;
                        setError499(dataNew.errors[errorType][0])
                        setPopup499(true)
                        return;
                    }
                    setShowTourConnections(false)
                    window.location.href = data;
                })
        } else {
            postDataWebNoResponse('/api/desktop/insert', newArr)
                .then((res) => Promise.all([res.status, res.json()]))
                .then(([status, data]) => {
                    if (status === 401) {
                        logout()
                        return;
                    }
                    if (status === 500) {
                        setPopup500(true)
                        return;
                    }
                    if (status === 499) {
                        var errorType = data.type;
                        setError499(data.errors[errorType][0])
                        setPopup499(true)
                        return;
                    }
                    if (status === 400) {
                        setLoading(false);
                        setErrorMessage("Please enter valid credentials for each field.")
                        setShowError(true);
                    } else {
                        setShowTourConnections(false)
                        api.open({
                            message: cloudDetail.name + ' Cloud Account has been successfully connected to Amove.',
                            icon: <img src={toastIcon} alt="toastIcon"/>,
                            duration: 3,
                        });
                        sendDataToMixPanel('Cloud Account has been successfully connected to Amove.', user.username, {
                            'App': 'Web App',
                            'Drive Name': cloudDetail.name
                        })
                        clearFields();
                        setUpdateCloudAccounts(!updateCloudAccounts)
                        var ele = document.getElementsByName("cloud-brand");
                        for (var i = 0; i < ele.length; i++)
                            ele[i].checked = false;
                        const name = "";
                        const value = "";
                        const logo = "";
                        const text = "";
                        const type = "";
                        const isActive = false;
                        setRadiaCheck(s => ({...s, name, logo, text, value, type, isActive}));
                        setLoading(false);
                        // setLastAddedCloudAccount(data.id);
                        if (hideBTNs) {
                            setHideBTNs(false)
                            /*if (!agentIsRunning) {
                                setShowAgentOnce(true)
                            } else {*/
                            localStorage.setItem("dashboardTourStep", 1)
                            setShowTourDashboard(true);
                            navigate("/?accounts=true&onboarding=true&lastid=" + data.id)
                            //}
                        } else {
                            navigate("/?accounts=true&lastid=" + data.id)
                        }
                    }
                    setLoading(false);
                })
        }
    };

    const setUpNewAmoveStorage = () => {
        var dataToPost = {
            "cloudAccountName": "Amove",
            "bucketName": "amovebucket",
            "shared": false
        }
        setLoading(true)
        getDataWithTokenPOST("/api/cloudaccount/add_storage", dataToPost)
            .then((res) => Promise.all([res.status, res.json()]))
            .then(([status, response]) => {
                setLoading(false);
                if (status === 401) {
                    setEndpoint("/api/cloudaccount/add_storage")
                    setShowPopupSupport(true)
                    // logout()
                    setLoading(false);
                    return;
                }
                if (status === 500) {
                    setPopup500(true);
                    setLoading(false);
                    return;
                }
                if (status === 499) {
                    var errorType = response.type;
                    setError499(response.errors[errorType][0])
                    setPopup499(true)
                } else {
                    api.open({
                        message: `New Amove Storage Created.`,
                        icon: <img src={toastIcon} alt="toastIcon"/>,
                        duration: 5
                    });
                    setLoading(false);
                    navigate(`/dashboard?amove=true`);
                }
            })

    };
    const setUpNewIDrive = () => {
        var dataToPost = {
            "userEmail": "",
            "cloudAccountName": "Amove",
            "bucketTitle": "amovebucket",
            "region": selectedRegions,
            "defaultPassword": "",
            "shared": false
        }
        setLoadingAmove(true)
        getDataWithTokenPOST("/api/cloudaccount/idrive_add_storage", dataToPost)
            .then((res) => Promise.all([res.status, res.json()]))
            .then(([status, response]) => {
                setLoadingAmove(false);
                if (status === 401) {
                    setEndpoint("/api/cloudaccount/idrive_add_storage")
                    setShowPopupSupport(true)
                    // logout()
                    setLoadingAmove(false);
                    return;
                }
                if (status === 500) {
                    setPopup500(true);
                    setLoadingAmove(false);
                    return;
                }
                if (status === 499) {
                    var errorType = response.type;
                    setError499(response.errors[errorType][0])
                    setPopup499(true)
                    setLoadingAmove(false);
                } else {
                    api.open({
                        message: `New Amove Storage Created.`,
                        icon: <img src={toastIcon} alt="toastIcon"/>,
                        duration: 5
                    });

                    setShowTourConnections(false)
                    setShowOnlyToolTip(false)
                    localStorage.setItem("showOnlyToolTip","false")

                    setLoadingAmove(false);
                    navigate("/?accounts=true&lastid=" + response.id)
                }
            })

    };

    useEffect(() => {
        if (agentIsRunning) {
            navigate("/add-cloud-account");
        }
    }, [agentIsRunning]);

    function getCloudFields(cloudType) {
        cloudType = parseInt(cloudType);
        if (cloudType === 9998) {
            return (
                <SetupNFS type="NFS"/>
            )
        }
        if (cloudType === 9999) {
            return (
                <SetupNFS type="SMB"/>
            )
        }
        if (cloudType === 1) {
            return (
                <div className={"field-wrapper"}>
                    {/* ${ ? "help-circle" : null}*/}
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="accessKey" placeholder="Enter access key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="secret-key" className="form-control" onChange={inputEvent} name="secretKey" placeholder="Enter secret key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 2) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="accessKey" placeholder="Enter access key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="secret-key" className="form-control" onChange={inputEvent} name="secretKey" placeholder="Enter secret key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 4) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="accessKey" placeholder="Storage account name"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="secret-key" className="form-control" onChange={inputEvent} name="secretKey" placeholder="Enter account key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 8 || cloudType === 64) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="accessKey" placeholder="Enter access key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="secret-key" className="form-control" onChange={inputEvent} name="secretKey" placeholder="Enter secret key"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="serviceUrl" placeholder="URL(Generic S3 endpoint)"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 16) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <textarea id="access-key" className="form-control" onChange={inputEvent} name="credentialsData" placeholder="Service Accounts Key(JSON)"></textarea>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 32) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="credentialsData" placeholder="Enter Api Token"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 10) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="emailAddress" placeholder="Email"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="password" id="give-name" className="form-control" onChange={inputEvent} name="password" placeholder="Password"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 11) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="access-key" className="form-control" onChange={inputEvent} name="emailAddress" placeholder="Email"/>
                    </div>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="password" id="give-name" className="form-control" onChange={inputEvent} name="password" placeholder="Password"/>
                    </div>
                </div>
            )
        }
        if (cloudType === 128 || cloudType === 256 || cloudType === 512 || 1024) {
            return (
                <div className={"field-wrapper"}>
                    <div className={`form-group  ${showError ? "has-error" : ""}`}>
                        <input type="text" id="give-name" className="form-control" onChange={inputEvent} name="name" placeholder="Name your cloud account"/>
                    </div>
                </div>
            )
        }

    }


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());

        const nodeList = document.querySelectorAll("#brandNames li");
        for (let i = 0; i < nodeList.length; i++) {
            if (nodeList[i].getAttribute('data-title').toLowerCase().includes(e.target.value.toLowerCase())) {
                nodeList[i].classList.add("active");
            } else {
                nodeList[i].classList.remove("active");
            }
        }

    };
    const onChangeRegoin = (value) => {
        setSelectedRegions(value);
        console.log(value)
    };


    return (
        <>
            {contextHolder}
            <div id="main-content" className={`${showTourConnections ? "tour-index" : ""}`}>
                {showTourConnections &&
                    <div className="tour-overlay"></div>
                }
                <div className="container-fluid">
                    <div className="main-content-body dashboard-home add-cloud-account-page">
                        <div className="cloud-brands-wrapper">
                            <div className={`left-content ${!radioCheck.isActive ? "brand-grid-5" : "brand-grid-4"}`}>
                                <div className={`drive-brands connection-drive-brands ${cloudAccounts.filter((item) => item.internalStorage).length < 1 && cloudAccountsDone ? "not-amove-storage" : ""}`}>
                                    <div className={`drive-brands-wrapper ${!showFreeStorage ? "remove-padding" : ""}`}>
                                        <div className="row">
                                            <div className="col-lg-5 col-md-12">

                                               {/* {showTourConnections &&
                                                    <div className="onboarding-back">
                                                        <Link to="/onboarding">
                                                            <i className="fa-solid fa-arrow-left"></i>
                                                            <span>Back</span>
                                                        </Link>
                                                    </div>
                                                }*/}
                                                {cloudCounts.length > 0 && (
                                                    <div className="connections-wrapper">
                                                        <h3>Connections</h3>
                                                        <ul className="accounts">
                                                        {cloudCounts.map((item, i) => (
                                                                <li key={i} className={` ${item.count > 0 ? "show" : ""}`}>{getIcon(item.cloudType, item.cloudIconType)}<span className={` ${item.count > 1 ? "show" : ""}`}>{item.count}</span></li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                            {user.userType !== 32 && user.userType !== 64 &&
                                                <div className="col-lg-7 col-md-12">
                                                    {(showFreeStorage || hideBTNs) &&
                                                        <div className={`free-storage no-flex ${radioCheck.isActive ? "" : "not-selected"}`}>
                                                          {/*  <h3 className="sub-heading">Create a new Amove <br/>
                                                                Storage region.</h3>

                                                            <Select
                                                                className={` ${regions !== '' && regions !== null ? "selected" : ''}`}
                                                                showSearch
                                                                optionFilterProp="children"
                                                                onChange={onChangeRegoin}
                                                                placeholder="Select a Region"
                                                                value={selectedRegions}
                                                                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                                                options={regions.map((item) => ({
                                                                    label: item.name, value: item.code,
                                                                }))}
                                                            />
                                                            <a href="#" className={`brand-icon ${selectedRegions === 'Select a Region' || loadingAmove ? 'disabled' : ''}`} onClick={(e) => {
                                                                e.preventDefault();
                                                                setUpNewIDrive()
                                                            }}>
                                                                {loadingAmove &&
                                                                    <Spin indicator={<LoadingOutlined style={{fontSize: 22}} spin/>}/>
                                                                }
                                                                <img src={!isDark ? pageLogoWhite : pageLogo} alt="logo"/></a>

                                                            <span className="red-error fix-2-lines-desktop" title={errorText}>{errorText}</span>*/}
                                                            <ProvisionAmoveStorage/>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        {/* Connections tour first step  showTourConnections*/}
                                        <div className={`brands-header ${showTourConnections ? "highlighted-tour" : ""}`}>
                                            {/*<div className="brands-header">*/}
                                            <div className="content-wrapper">
                                                <h3 className='sub-heading'>Connect your existing Cloud or Local Storage</h3>
                                                {/* Show this p tag when brands-header have class highlighted-tour */}
                                                {showTourConnections &&
                                                    <p>Choose a provider to get started</p>
                                                }
                                            </div>
                                            {/* Hide this form tag when brands-header have class highlighted-tour */}
                                            {!showTourConnections &&
                                                <div className="form">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search Cloud Provider"
                                                            value={searchQuery}
                                                            onChange={handleSearchChange}
                                                        />
                                                        <a href="#" className="icon" onClick={(e) => e.preventDefault()}>
                                                            <img src={searchIcon} alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className={`brands-main-wrapper`}>
                                            {/*<ul className="brands highlighted-tour" id="brandNames">*/}
                                            <ul className="brands  highlighted-tour" id="brandNames">
                                                {config.environment === "Dev" &&
                                                    <>
                                                        {/*
                                                    <li>
                                                        <input type="radio" id="boxLogo" data-logo={box} data-width={50} data-name="Box" name="cloud-brand" onChange={onChangeCloud} value="10"/>
                                                        <label htmlFor="boxLogo">
                                                            <img src={box} alt="logo" style={{maxWidth: '50px'}}/>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <input type="radio" id="googleDriveLogo" data-logo={googleDrive} data-width={150} data-name="Google Drive" name="cloud-brand" onChange={onChangeCloud} value="10"/>
                                                        <label htmlFor="googleDriveLogo">
                                                            <img src={googleDrive} alt="logo" style={{maxWidth: '150px'}}/>
                                                        </label>
                                                    </li>
                                            <li>
                                                <input type="radio" id="ibm" data-logo={ibm} data-width={140} data-name="IBM Cloud" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                <label htmlFor="ibm">
                                                    <img src={ibm} alt="logo" className="ibm" style={{maxWidth: '140px'}}/>
                                                </label>
                                            </li>*/}
                                                    </>
                                                }
                                                {/*    {cloudAccounts.filter((item) => item.internalStorage).length < 1 &&
                                                <li>
                                                    <input type="radio" id="googleDriveLogo" data-logo={googleDrive} data-width={150} data-name="Google Drive" name="cloud-brand" onChange={onChangeCloud} value="10"/>
                                                    <label htmlFor="googleDriveLogo">
                                                        <img src={pageLogo} alt="logo" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                            }*/}
                                                <li data-title="Dropbox" className="active">
                                                    <input type="radio" id="dropBoxLogo" data-logo={dropBox} data-width={130} data-name="Dropbox" name="cloud-brand" onChange={onChangeCloud} value="128"/>
                                                    <label htmlFor="dropBoxLogo">
                                                        <img src={dropBox} alt="logo" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Box" className="active">
                                                    <input type="radio" id="boxLogo" data-logo={box} data-width={50} data-name="Box" name="cloud-brand" onChange={onChangeCloud} value="256"/>
                                                    <label htmlFor="boxLogo">
                                                        <img src={box} alt="logo" style={{maxWidth: '50px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Google Drive" className="active">
                                                    <input type="radio" id="googleDriveLogo" data-logo={googleDrive} data-width={140} data-name="Google Drive" name="cloud-brand" onChange={onChangeCloud} value="1024"/>
                                                    <label htmlFor="googleDriveLogo">
                                                        <img src={googleDrive} alt="logo" style={{maxWidth: '140px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="FarmeIO" className="active">
                                                    <input type="radio" id="farmeIOIcon" data-logo={farmeIOIcon} data-width={120} data-name="farmeIO" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="farmeIOIcon" className="text-logo">
                                                        <img src={farmeIOIcon} alt="logo" style={{maxWidth: '120px'}}/>
                                                        {/*    <p className="tag">COMING SOON</p>*/}
                                                    </label>
                                                </li>
                                                <li data-title="AWS" className="active">
                                                    <input type="radio" id="awsLogo" data-logo={awsLogo} data-width={50} data-name="AWS" name="cloud-brand" onChange={onChangeCloud} value="1"/>
                                                    <label htmlFor="awsLogo">
                                                        <img src={awsLogo} alt="logo" style={{maxWidth: '50px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Azure" className="active">
                                                    <input type="radio" id="azureLogo" data-logo={azureLogo} data-width={140} data-name="Azure" name="cloud-brand" onChange={onChangeCloud} value="4"/>
                                                    <label htmlFor="azureLogo">
                                                        <img src={azureLogo} alt="logo" style={{maxWidth: '140px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Google Cloud Provider" className="active">
                                                    <input type="radio" id="googleCloudLogo" data-logo={googleCloudLogo} data-width={144} data-name="GCP" name="cloud-brand" onChange={onChangeCloud} value="16"/>
                                                    <label htmlFor="googleCloudLogo">
                                                        <img src={googleCloudLogo} alt="logo" style={{maxWidth: '144px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Wasabi" className="active">
                                                    <input type="radio" id="wasabiCloudLogo" data-logo={wasabiCloudLogo} data-width={120} data-name="Wasabi" name="cloud-brand" onChange={onChangeCloud} value="2"/>
                                                    <label htmlFor="wasabiCloudLogo">
                                                        <img src={wasabiCloudLogo} alt="logo" style={{maxWidth: '120px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Storj" className="active">
                                                    <input type="radio" id="storjLogo" data-logo={storjLogo} data-width={126} data-name="Storj" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="storjLogo">
                                                        <img src={storjLogo} alt="logo" className="storjLogo" style={{maxWidth: '126px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Backblaze" className="active">
                                                    <input type="radio" id="Backblaze" data-logo={Backblaze} data-width={130} data-name="Backblaze" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="Backblaze">
                                                        <img src={Backblaze} alt="logo" className="Backblaze" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="IDrive" className="active">
                                                    <input type="radio" id="idrive" data-logo={idrive} data-width={120} data-name="IDrive" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="idrive">
                                                        <img src={idrive} alt="logo" className="idrive" style={{maxWidth: '120px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="S3" className="active">
                                                    <input type="radio" id="s3Logo" data-logo={s3Logo} data-width={120} data-name="S3" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="s3Logo">
                                                        <img src={s3Logo} alt="logo" className="s3logo" style={{maxWidth: '120px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Perifery" className="active">
                                                    <input type="radio" id="Perifery" data-logo={perifery} data-width={130} data-name="Perifery" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="Perifery">
                                                        <img src={perifery} alt="logo" className="perifery" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="One Drive" className="active">
                                                    <input type="radio" id="oneDriveLogo" data-logo={oneDrive} data-width={130} data-name="One Drive" name="cloud-brand" onChange={onChangeCloud} value="512"/>
                                                    <label htmlFor="oneDriveLogo">
                                                        <img src={oneDrive} alt="logo" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="DigitalOcean" className="active">
                                                    <input type="radio" id="DigitalOcean" data-logo={DigitalOcean} data-width={161} data-name="DO" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="DigitalOcean">
                                                        <img src={DigitalOcean} alt="logo" className="DigitalOcean" style={{maxWidth: '161px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Seagate" className="active">
                                                    <input type="radio" id="seagateLogo" data-logo={seagateLogo} data-width={130} data-name="Seagate" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="seagateLogo">
                                                        <img src={seagateLogo} alt="logo" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="Cloudflare" className="active">
                                                    <input type="radio" id="Cloudflare" data-logo={Cloudflare} data-width={130} data-name="Cloudflare" name="cloud-brand" onChange={onChangeCloud} value="64"/>
                                                    <label htmlFor="Cloudflare">
                                                        <img src={Cloudflare} alt="logo" className="Cloudflare" style={{maxWidth: '130px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="OVHcloud" className="active">
                                                    <input type="radio" id="ovhLogo" data-logo={ovhLogo} data-width={140} data-name="OVH" name="cloud-brand" onChange={onChangeCloud} value="8"/>
                                                    <label htmlFor="ovhLogo">
                                                        <img src={ovhLogo} alt="logo" className="ovhLogo" style={{maxWidth: '140px'}}/>
                                                    </label>
                                                </li>
                                                <li data-title="NFS Connect" className="active">
                                                    <input type="radio" id="NFS" data-text="NFS Connect" data-logo={NFSNewLogo} data-width={40} data-name="NFS" name="cloud-brand" onChange={onChangeCloud} value="9998"/>
                                                    <label htmlFor="NFS" className="text-logo">
                                                        <img src={NFSNewLogo} alt="logo" style={{maxWidth: '40px'}}/>
                                                        <h3>NFS Connect</h3>
                                                    </label>
                                                </li>
                                                <li data-title="SMB Connect" className="active">
                                                    <input type="radio" id="SMB" data-text="SMB Connect" data-logo={SMBLogo} data-width={40} data-name="SMB" name="cloud-brand" onChange={onChangeCloud} value="9999"/>
                                                    <label htmlFor="SMB" className="text-logo">
                                                        <img src={SMBLogo} alt="logo" style={{maxWidth: '40px'}}/>
                                                        <h3>SMB Connect</h3>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`right-content ${radioCheck.isActive ? "" : "no-connection"}`}>
                                {/* Tour start */}
                                <div className="cloud-right-bar tour-start">
                                    <div className={`no-data ${radioCheck.isActive ? "" : "active"}`}>
                                        <img src={`${noData}`} alt="No Data"/>
                                        <p>Select a cloud provider.</p>
                                    </div>
                                    <div className={`selected-brand ${radioCheck.isActive ? "active" : ""}`}>
                                        <div className="brand-body">
                                            <div className="brand-header-image">
                                                <div className="wrapper">
                                                    <img src={radioCheck.logo} alt="Selected Brand" style={{maxWidth: radioCheck.width + 'px'}} className={`cloud-icon-${radioCheck.width}`}/>
                                                    {(radioCheck.text !== "NFS CONNECT" || radioCheck.text !== "SMB CONNECT") &&
                                                        <h3>{radioCheck.text}</h3>
                                                    }
                                                </div>
                                                <div className="tour-tooltip tour-connection-step-1">
                                                    <div className="tour-tooltip-wrapper">
                                                        {/*<a href="#" className="cross">
                                                            <img src={crossBalckIcon} alt="icon"/>
                                                        </a>*/}
                                                        <h3>Connect to your existing cloud account</h3>
                                                        <ul className="steps full">
                                                            <li className="active"><span className="dot"></span></li>
                                                            <li><span className="dot"></span></li>
                                                        </ul>
                                                        <p className="p">Name your cloud account</p>
                                                        <p>Please name your cloud account and then click
                                                            "Connect" to grant access and permissions</p>
                                                        <div className="btn-wrapper">
                                                            <a href="#" className="btn-tour transparent">Previous</a>
                                                            {/*<a href="#" className="btn-tour">Next</a>*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h3>Enter your {radioCheck.value} credentials</h3>
                                            <div className="form" id="add-cloud-fields">
                                                {getCloudFields(radioCheck.type)}

                                                {showError &&
                                                    <div className="form-group">
                                                        <span className="red-error">{errorMessage}</span>
                                                    </div>
                                                }
                                                {(radioCheck.text !== "NFS Connect" && radioCheck.text !== "SMB Connect") &&
                                                    <>
                                                        <div className="form-group submit">
                                                            <Button className="btn-style small" onClick={addCloudAccount} loading={loading}>Connect</Button>
                                                        </div>
                                                        <div className={`tour-tooltip tour-connection-step-2 ${showTourConnections || showOnlyToolTip? "active" : ""}`}>
                                                            <div className="tour-tooltip-wrapper">
                                                                <a href="#" className="cross" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowTourConnections(false)
                                                                    setShowOnlyToolTip(false)
                                                                    localStorage.setItem("showOnlyToolTip","false")
                                                                }}>
                                                                    <img src={crossBalckIcon} alt="icon"/>
                                                                </a>
                                                                <h3>Connect to your existing cloud account</h3>
                                                                <ul className="steps full">
                                                                    <li className="active"><span className="dot"></span></li>
                                                                    <li className="active"><span className="dot"></span></li>
                                                                </ul>
                                                                <p className="p">Enter your {radioCheck.value} credentials</p>
                                                            </div>
                                                        </div>
                                                    </>
                                                }

                                                {(radioCheck.text === "NFS Connect" || radioCheck.text === "SMB Connect") &&
                                                    <div className={`tour-tooltip tour-connection-step-2 ${showTourConnections || showOnlyToolTip? "active" : ""}`}>
                                                        <div className="tour-tooltip-wrapper">
                                                            <a href="#" className="cross" onClick={(e) => {
                                                                e.preventDefault();
                                                                setShowTourConnections(false)
                                                                setShowOnlyToolTip(false)
                                                                localStorage.setItem("showOnlyToolTip","false")
                                                            }}>
                                                                <img src={crossBalckIcon} alt="icon"/>
                                                            </a>
                                                            <h3>Connect to your existing local storage</h3>
                                                            <ul className="steps full">
                                                                <li className="active"><span className="dot"></span></li>
                                                                <li className="active"><span className="dot"></span></li>
                                                            </ul>
                                                            <p className="p">Enter your {radioCheck.value} credentials</p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal title="Assign Projects" className="manual-user-type create-storage-popup" centered open={isCreateStorage} onOk={() => {
                setIsCreateStorage(false);
            }} onCancel={() => {
                setIsCreateStorage(false);
            }}>
                <div className="manual-user-modal-wrapper">
                    <div className="create-team">
                        <AmoveStorage popup={true}/>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showAgentOnce} onOk={OnboardingAgentOk} onCancel={OnboardingAgentCancel}
                centered
                className="download-client-popup"
                footer={null}
                title={null}
            >
                <div className="cloud-drive-modal-wrapper">
                    <div className="row row-eq-height">
                        <div className="col-md-4 ">
                            <div className="left-side">
                                <div className="logo-img-wrapper">
                                    <img src={isDark ? pageLogoWhite : pageLogo} alt="logo"/>
                                </div>
                                <div className="content-wrapper">
                                    <h3>Your first cloud is now connected.</h3>
                                    <h3><a href="https://www.amove.io/download/" target='_blank' className='download-icon'><i className="fa fa-download"></i></a>
                                        Let's download the Amove Desktop Client <br/>
                                        and set up your first Drive.</h3>
                                    <h3>To connect more clouds or set up Amove
                                        storage with 1-click, <a href="#" onClick={(e) => {
                                            e.preventDefault()
                                            OnboardingAgentCancel();
                                        }}>go here</a>.</h3>
                                </div>


                                <div className="text-center launch-amove-btn">

                                    {config.environment === 'POC' && !showSingleButton &&
                                        <>
                                            {!isWindows &&
                                                <a href='#' onClick={(e) => {
                                                    e.preventDefault();
                                                    checkAgent(true)
                                                    setShowButtons(false)
                                                    sendDataToMixPanel('Amove-intel-POC downloaded.', user.username, {
                                                        'App': 'Web App'
                                                    })
                                                    // Create a temporary link element
                                                    const link = document.createElement('a');
                                                    link.href = "https://d2h7a876wzviri.cloudfront.net/Amove-intel-POC.pkg";
                                                    link.download = "Amove-Mac-latest.pkg";
                                                    link.target = "_blank";

                                                    // Append the link to the body
                                                    document.body.appendChild(link);

                                                    // Trigger the download by clicking the link
                                                    link.click();

                                                    // Remove the link from the document
                                                    document.body.removeChild(link);
                                                }} className="btn-style blue">Download Amove</a>
                                            }
                                            {isWindows &&
                                                <a href='#' onClick={(e) => {
                                                    e.preventDefault();
                                                    checkAgent(true)
                                                    setShowButtons(false)
                                                    sendDataToMixPanel('Amove-64bit-POC downloaded.', user.username, {
                                                        'App': 'Web App'
                                                    })

                                                    // Create a temporary link element
                                                    const link = document.createElement('a');
                                                    link.href = "https://d2h7a876wzviri.cloudfront.net/Amove-64bit-POC.exe";
                                                    link.download = "Amove-Mac-latest.pkg";
                                                    link.target = "_blank";

                                                    // Append the link to the body
                                                    document.body.appendChild(link);

                                                    // Trigger the download by clicking the link
                                                    link.click();

                                                    // Remove the link from the document
                                                    document.body.removeChild(link);
                                                }} className="btn-style blue">Download Amove</a>
                                            }
                                        </>
                                    }
                                    {config.environment !== 'POC' && !showSingleButton &&
                                        <>
                                            {!isWindows &&
                                                <a href='#' onClick={(e) => {
                                                    e.preventDefault();
                                                    checkAgent(true)
                                                    setShowButtons(false)
                                                    sendDataToMixPanel('Amove-Mac-latest downloaded.', user.username, {
                                                        'App': 'Web App'
                                                    })
                                                    // setShowSingleButton(true)

                                                    // Create a temporary link element
                                                    const link = document.createElement('a');
                                                    link.href = "https://d2h7a876wzviri.cloudfront.net/Amove-Mac-latest.pkg";
                                                    link.download = "Amove-Mac-latest.pkg";
                                                    link.target = "_blank";

                                                    // Append the link to the body
                                                    document.body.appendChild(link);

                                                    // Trigger the download by clicking the link
                                                    link.click();

                                                    // Remove the link from the document
                                                    document.body.removeChild(link);
                                                }} className="btn-style blue">Download Amove</a>
                                            }
                                            {isWindows &&
                                                <a href='#' onClick={(e) => {
                                                    e.preventDefault();
                                                    checkAgent(true)
                                                    setShowButtons(false)
                                                    // setShowSingleButton(true)
                                                    sendDataToMixPanel('Amove-Win-latest downloaded.', user.username, {
                                                        'App': 'Web App'
                                                    })
                                                    // Create a temporary link element
                                                    const link = document.createElement('a');
                                                    link.href = "https://d2h7a876wzviri.cloudfront.net/Amove-Win-latest.exe";
                                                    link.download = "Amove-Mac-latest.pkg";
                                                    link.target = "_blank";

                                                    // Append the link to the body
                                                    document.body.appendChild(link);

                                                    // Trigger the download by clicking the link
                                                    link.click();

                                                    // Remove the link from the document
                                                    document.body.removeChild(link);
                                                }} className="btn-style blue">Download Amove</a>
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="right-side">
                                <img src={`${popupImage}`} alt="popupImage"/>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddCloudAccount;

